import { useSyncedRef } from "@react-hookz/web";
import { useEffect } from "react";

import { useIntersection } from "./intersection";

type InfiniteScrollTriggerArguments = {
  disabled?: boolean;
  hasNextPage: boolean;
  isLoading: boolean;
  onLoadMore: VoidFunction;
  options?: IntersectionObserverInit;
};

export const useInfiniteScrollTriggerReference = ({
  disabled,
  hasNextPage,
  isLoading,
  onLoadMore,
  options = {
    threshold: [0.25, 1],
  },
}: InfiniteScrollTriggerArguments) => {
  const { captureIntersectionElement, intersection } = useIntersection(options);
  const latestCallback = useSyncedRef(onLoadMore);

  // Use isLoading here to prevent the intersection observer keeps on the screen and stop to fetch next page
  // Downside is it may fetch twice because of toggling isLoading
  useEffect(() => {
    const shouldLoadMore = !disabled && !isLoading && hasNextPage && intersection?.isIntersecting;
    if (!shouldLoadMore) return;
    latestCallback.current();
  }, [disabled, hasNextPage, intersection?.isIntersecting, isLoading, latestCallback]);

  return { infiniteScrollTriggerReference: captureIntersectionElement };
};
